import React, { useState } from 'react'
import { Alert, Box, Grid, Link, Typography } from '@mui/material'
import Logo from '../../images/logo_cropped.jpg'
import { useNavigate } from 'react-router-dom'
import Page from '../_library/Page'
import useAuth from '../../hooks/useAuth'
import { HOME } from '../../_constants/routes'
import { SignInPage } from '@toolpad/core'
import PasswordField from './PasswordField'
import { useTranslation } from 'react-i18next'
import ResetPasswordForm from './ResetPasswordForm'


export const LoginPage = () => {
  
  const auth = useAuth()
  const navigate = useNavigate()
  const { t } = useTranslation()
  
  const [passwordReset, setPasswordReset] = useState(false)
  const [subtitle, setSubtitle] = useState(null)
  
  const signIn = async (provider, formData) => {
    console.log(`${provider.id} signin`)
    if (provider.id === 'credentials')
      return passwordReset
        ? auth.resetPasswordAction(formData.get('email'))
          .then(() => setSubtitle({ severity: 'success', message: 'Un email a été envoyé' }))
          .catch(err => {
            console.error(err)
            setSubtitle({ severity: 'error', message: 'Problème avec l\'envoi d\'email. Plus d\'info dans la console' })
          })
        : auth.signIn({ email: formData.get('email'), password: formData.get('password') })
          .catch(e => setSubtitle({ severity: 'error', message: e.message }))
    if (provider.id === 'google')
      return auth.googleSignIn()
        .then(() => navigate(HOME))
        .catch(e => setSubtitle({ severity: 'error', message: e.message }))
  }
  
  return (
    <Page containerSx={{ minHeight: '100vh' }}>
      <Grid container sx={{ minHeight: '100vh' }}>
        <Grid id='loginForm' size={{ xs: 12, md: 7 }} alignContent='center' justifyItems='center' sx={{ bgcolor: 'primary.dark', position: 'relative' }}>
          {passwordReset
            ? <ResetPasswordForm onClose={() => setPasswordReset(false)} />
            : <SignInPage
              signIn={signIn}
              providers={[
                { id: 'google', name: 'Google' },
                { id: 'credentials', name: 'Email and Password' },
              ]}
              slots={{
                subtitle: () => subtitle && <Alert sx={{ mb: 2, px: 1, py: 0.25 }} severity={subtitle.severity}>{t(subtitle.message)}</Alert>,
                passwordField: () => <PasswordField />,
                forgotPasswordLink: () => <Link variant='body2' onClick={() => setPasswordReset(true)}>Forgot password?</Link>,
              }}
            />
          }
          <Box component='footer' sx={{ position: 'absolute', width: '100%', bottom: t => t.spacing(2) }}>
            <Typography variant='body2' color='grey.800' align='center'>Version {window.version}</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 5 }} alignContent='center' justifyItems='center' display={{ xs: 'none', md: 'block' }}>
          <Box component='img' src={Logo} display='block' maxWidth='90%' alignSelf='center' />
          <Typography fontSize='100px' lineHeight={.9} fontWeight={900}>
            MPV<Box component='span' color='secondary.main' fontSize='120px' lineHeight={.5}>+</Box>
          </Typography>
          <Typography textTransform='uppercase' color='grey.700' fontSize='20px'>Airclub management software</Typography>
        </Grid>
      </Grid>
    </Page>
  )
}

export default LoginPage
